import { render, staticRenderFns } from "./newIosTier.vue?vue&type=template&id=5caf23b8&"
import script from "./newIosTier.vue?vue&type=script&lang=js&"
export * from "./newIosTier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports